import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	constructor(private http: HttpClient) { }

	get(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.notification:get',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	set(id: any, actions: any = [], options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.notification:set',
			params: {
				id: id,
				actions: actions,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
    changeStateFromInstruction(instructionId: number,etat: string): Observable<JSONRpcResponse> {
        let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.notification:changeStateFromInstruction',
			params: {
				instructionId: instructionId,
				etat: etat
			},
		})
        return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
    }
}
